console.log('[mcc-coll] script loaded');

try {

  // === SORT DROPDOWN ===
  (function mccSort() {
    console.log('[mcc-sort] init starting');
    var sortSelect = document.getElementById('SortBy')
                  || document.querySelector('[data-sort-select]')
                  || document.querySelector('select[name="sort_by"]')
                  || document.querySelector('.mcc-coll-resultsbar__sort');
    if (!sortSelect) {
      console.warn('[mcc-sort] NO select found via any selector');
      return;
    }
    console.log('[mcc-sort] found select:', sortSelect.id || sortSelect.name || sortSelect.className);

    sortSelect.addEventListener('change', function(e) {
      console.log('[mcc-sort] change fired, value=', e.target.value);
      var value = e.target.value;
      var url = new URL(window.location.href);
      if (value && value !== 'manual') {
        url.searchParams.set('sort_by', value);
      } else {
        url.searchParams.delete('sort_by');
      }
      url.searchParams.delete('page');
      console.log('[mcc-sort] navigating to', url.toString());
      window.location.href = url.toString();
    });
    console.log('[mcc-sort] change listener attached');
  })();

  // === INFINITE SCROLL ===
  (function mccInfiniteScroll() {
    var grid = document.querySelector('.mcc-coll-grid');
    if (!grid) {
      console.warn('[mcc-coll] grid not found');
      return;
    }

    var loader = document.querySelector('.mcc-coll-loader');
    var sentinel = document.querySelector('.mcc-coll-sentinel');
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.className = 'mcc-coll-sentinel';
      sentinel.innerHTML = '&#8203;';
      sentinel.style.cssText = 'display:block !important;height:20px;width:100%;grid-column:1 / -1;';
      grid.parentElement.appendChild(sentinel);
      console.warn('[mcc-coll] sentinel created by JS');
    }
    sentinel.style.display = 'block';
    if (!sentinel.innerHTML.trim()) sentinel.innerHTML = '&#8203;';

    var totalProducts = parseInt(grid.dataset.totalProducts || '0', 10);
    var perPage = parseInt(grid.dataset.perPage || '24', 10);
    var currentPage = parseInt(grid.dataset.currentPage || '1', 10);
    var totalPages = Math.ceil(totalProducts / perPage);

    console.log('[mcc-coll] init:', {
      totalProducts: totalProducts,
      perPage: perPage,
      currentPage: currentPage,
      totalPages: totalPages,
      sentinelDisplay: getComputedStyle(sentinel).display
    });

    if (!totalProducts) {
      console.warn('[mcc-coll] totalProducts is 0, aborting');
      return;
    }

    var isLoading = false;
    var isExhausted = currentPage >= totalPages;

    function showEndMessage() {
      if (loader) loader.hidden = true;
      if (document.querySelector('.mcc-coll-end')) return;
      var p = document.createElement('p');
      p.className = 'mcc-coll-end';
      p.style.cssText = 'text-align:center;padding:40px 0;color:#6b7280;font-size:13px;grid-column:1 / -1;';
      p.textContent = "You've seen all " + totalProducts + " products";
      grid.parentElement.appendChild(p);
    }

    if (isExhausted) {
      console.log('[mcc-coll] exhausted at init');
      showEndMessage();
      return;
    }

    function loadNextPage() {
      if (isLoading || isExhausted) return;
      var nextPage = currentPage + 1;
      if (nextPage > totalPages) {
        isExhausted = true;
        showEndMessage();
        observer.disconnect();
        return;
      }
      isLoading = true;
      if (loader) loader.hidden = false;

      var url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
      var fetchUrl = url.toString();
      console.log('[mcc-coll] fetching', fetchUrl);

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.mcc-coll-grid');
          if (!newGrid) throw new Error('no grid in response HTML');
          var newCards = newGrid.querySelectorAll('.mcc-pdp__card, .mcc-coll-card, [data-product-id]');
          console.log('[mcc-coll] page', nextPage, 'returned', newCards.length, 'cards');

          if (newCards.length === 0) {
            isExhausted = true;
            showEndMessage();
            observer.disconnect();
            return;
          }

          var existing = {};
          grid.querySelectorAll('[data-product-id]').forEach(function(c) {
            existing[c.dataset.productId] = true;
          });

          var appended = 0;
          newCards.forEach(function(card) {
            var id = card.dataset.productId;
            if (id && existing[id]) return;
            grid.appendChild(card);
            appended++;
          });

          console.log('[mcc-coll] appended', appended);

          if (appended === 0) {
            isExhausted = true;
            showEndMessage();
            observer.disconnect();
            return;
          }

          currentPage = nextPage;
          grid.setAttribute('data-current-page', String(nextPage));
          isLoading = false;
          if (loader) loader.hidden = true;

          if (currentPage >= totalPages) {
            isExhausted = true;
            showEndMessage();
            observer.disconnect();
          }
        })
        .catch(function(err) {
          console.error('[mcc-coll] fetch failed:', err);
          isLoading = false;
          if (loader) loader.hidden = true;
        });
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          console.log('[mcc-coll] sentinel intersected');
          loadNextPage();
        }
      });
    }, { rootMargin: '600px 0px' });

    observer.observe(sentinel);
    console.log('[mcc-coll] observer attached');
  })();

  // === FILTER FORM ===
  (function mccFilterForm() {
    var form = document.querySelector('[data-filter-form]');
    if (!form) {
      console.warn('[mcc-filter] form not found');
      return;
    }
    form.addEventListener('change', function(e) {
      if (e.target.matches && e.target.matches('#SortBy, [data-sort-select]')) return;
      clearTimeout(form._submitTimer);
      form._submitTimer = setTimeout(function() { form.submit(); }, 120);
    });
    var clearBtn = document.querySelector('[data-clear-filters]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = form.getAttribute('action');
      });
    }
    console.log('[mcc-filter] attached');
  })();

  // === READ MORE TOGGLE ===
  (function mccReadMore() {
    var toggles = document.querySelectorAll('[data-expand-toggle]');
    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var body = btn.previousElementSibling;
        while (body && !body.hasAttribute('data-expandable')) {
          body = body.previousElementSibling;
        }
        if (!body) return;
        var isExpanded = body.classList.toggle('is-expanded');
        btn.textContent = isExpanded ? 'Read less ↑' : 'Read more ↓';
      });
    });
    if (toggles.length) console.log('[mcc-readmore] attached to', toggles.length, 'toggles');
  })();

  // === QUICK ADD (delegated on grid) ===
  (function mccQuickAdd() {
    'use strict';
    var grid = document.querySelector('.mcc-coll-grid');
    if (!grid) {
      console.warn('[mcc-quickadd] grid not found, handler not attached');
      return;
    }

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mcc-quickadd]');
      if (!btn) return;

      e.preventDefault();
      if (btn.disabled || btn.dataset.mccBusy === '1') return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('[mcc-quickadd] button missing data-variant-id');
        return;
      }

      var originalLabel = btn.textContent;
      btn.dataset.mccBusy = '1';
      btn.disabled = true;
      btn.classList.remove('is-added', 'is-error');
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', btn.getAttribute('data-quantity') || '1');

      // Ask for the cart drawer HTML so it can open with the new item (7 Oct 2026)
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || err.message || 'Add to cart failed');
            });
          }
          return res.json();
        })
        .then(function (json) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = '✓ Added';
          // Fire a custom event so any cart drawer / bubble code can react
          document.dispatchEvent(new CustomEvent('mcc:cart:added', {
            detail: { variantId: variantId }
          }));
          if (cartDrawer && json && json.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(json);
            return;
          }
          return refreshCartBubble();
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          btn.textContent = 'Unavailable';
          console.error('[mcc-quickadd]', err && err.message ? err.message : err);
        })
        .then(function () {
          setTimeout(function () {
            btn.textContent = originalLabel;
            btn.disabled = false;
            btn.dataset.mccBusy = '0';
            btn.classList.remove('is-added', 'is-error');
          }, 1800);
        });
    });

    /* Refresh the cart icon bubble using Shopify's sections API. Dawn uses
       #cart-icon-bubble; this code gracefully no-ops if that ID isn't present. */
    function refreshCartBubble() {
      return fetch('/?sections=cart-icon-bubble')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (sections) {
          if (!sections || !sections['cart-icon-bubble']) return;
          var target = document.getElementById('cart-icon-bubble');
          if (!target) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var replacement = doc.getElementById('cart-icon-bubble');
          if (replacement) target.innerHTML = replacement.innerHTML;
        })
        .catch(function () { /* silent */ });
    }

    console.log('[mcc-quickadd] attached to grid');
  })();

  // === FILTER PANEL ON PHONES AND TABLETS (7 Oct 2026) ===
  (function mccFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    var openBtn = document.querySelector('[data-open-filters]');
    if (!drawer || !openBtn) return;
    var backdrop = document.querySelector('[data-filter-backdrop]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (backdrop) backdrop.hidden = false;
      document.documentElement.classList.add('mcc-filter-open');
      openBtn.setAttribute('aria-expanded', 'true');
      var closeBtn = drawer.querySelector('[data-close-drawer]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      if (backdrop) backdrop.hidden = true;
      document.documentElement.classList.remove('mcc-filter-open');
      openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-close-drawer]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  })();

  // === FILTER GROUPS OPEN AND CLOSE (7 Oct 2026) ===
  (function mccFilterToggles() {
    document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.parentElement.querySelector('[data-filter-body]');
        var chevron = btn.querySelector('.mcc-coll-filter__chevron');
        var isOpen = btn.getAttribute('aria-expanded') !== 'false';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (body) body.hidden = isOpen;
        if (chevron) chevron.textContent = isOpen ? '+' : '−';
      });
    });
  })();

  console.log('[mcc-coll] all init complete');

} catch (err) {
  console.error('[mcc-coll] FATAL init error:', err);
}